import { makeAutoObservable } from 'mobx';

export interface IApiChangeLogItem {
	id: number;
	campaign_id: number;
	type: string;
	field: string;
	old_value: string;
	new_value: string;
	user_email: string;
	session_id: string;
	request_id: string;
	ts: string;
}

export interface IApiChangeLogsMetaData {
	ts_start: string;
	ts_end: string;
}

export interface IApiChangeLogsResponse {
	api_changes_log_data: IApiChangeLogItem[];
	MetaData: IApiChangeLogsMetaData;
	status: string;
}

export class ApiChangeLogModel {
	campaign_id: number;
	type: string;
	field: string;
	old_value: string;
	new_value: string;
	user_email: string;
	session_id: string;
	request_id: string;
	ts: string;

	constructor(data?: IApiChangeLogItem) {
		this.campaign_id = data?.campaign_id ?? 0;
		this.type = data?.type ?? '';
		this.field = data?.field ?? '';
		this.old_value = data?.old_value ?? '';
		this.new_value = data?.new_value ?? '';
		this.user_email = data?.user_email ?? '';
		this.session_id = data?.session_id ?? '';
		this.request_id = data?.request_id ?? '';
		this.ts = data?.ts ?? '';

		makeAutoObservable(this);
	}
}
